import {
    FETCH_GDPR_CONSENT_TEXT,
    FETCH_GDPR_CONSENT_TEXT_FAIL,
    FETCH_GDPR_CONSENT_TEXT_SUCCESS
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    consentTexts: {},
    gdprGetConsentTextSuccess: true
};

const fetchGdprConsentTextSuccess = (isSuccess) => (state, action) => {
    return {
        isFetching: false,
        consentTexts: { ...state.consentTexts, [action.key]: action.consentText },
        gdprGetConsentTextSuccess: isSuccess
    };
};

const handlers = {
    [FETCH_GDPR_CONSENT_TEXT_SUCCESS]: fetchGdprConsentTextSuccess(true),
    [FETCH_GDPR_CONSENT_TEXT_FAIL]: fetchGdprConsentTextSuccess(false)
};

export default function gdprConsentText(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchGdprConsentText(key, locale, evictCache) {
    return {
        type: FETCH_GDPR_CONSENT_TEXT,
        key,
        locale,
        isFetching: true,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const getGdprConsentText = (state, key) => {
    return state.gdprConsentText.consentTexts[key];
};

export const getGdprConsentTextState = (state) => {
    return state.gdprConsentText.gdprGetConsentTextSuccess;
};
